<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content" style="">
            <div class=" ">
                <el-tabs v-model="activeName" type="border-card">
                    <el-tab-pane label="传统" name="first" :key="'first'" v-if="hasAuth('customerLvyueTable2026')">
                        <customerLvyueTable2026 v-if="activeName === 'first'" />
                    </el-tab-pane>
                  <el-tab-pane label="传统增量" name="second" :key="'second'" v-if="hasAuth('customerLvyueTable2026Increment')">
                    <customerLvyueTableIncrement2026 v-if="activeName === 'second'" />
                  </el-tab-pane>
                  <el-tab-pane label="血液" name="third" :key="'third'" v-if="hasAuth('customerLvyueTable2026XY')">
                    <customerLvyueTable2026XY v-if="activeName === 'third'" />
                  </el-tab-pane>
                  <el-tab-pane label="厚宏" name="fourth" :key="'fourth'" v-if="hasAuth('customerLvyueTable2026HH')">
                    <customerLvyueTable2026HH v-if="activeName === 'fourth'" />
                  </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import customerLvyueTable2026 from './customerLvyueTable2026.vue'
import customerLvyueTableIncrement2026 from './customerLvyueTable2026Increment.vue'
import customerLvyueTable2026XY from './customerLvyueTable2026XY.vue'
import customerLvyueTable2026HH from './customerLvyueTable2026HH.vue'
export default {
    components: {
        customerLvyueTable2026,
        customerLvyueTableIncrement2026,
        customerLvyueTable2026XY,
        customerLvyueTable2026HH,
    },
    data() {
        return {
            activeName: "first",
        };
    },
    created() {
        // 标签页权限配置
        const tabs = [
            { name: 'first', auth: 'customerLvyueTable2026' },
            { name: 'second', auth: 'customerLvyueTable2026Increment' },
            { name: 'third', auth: 'customerLvyueTable2026XY' },
            { name: 'fourth', auth: '/customerLvyueTable2026HH' }
        ];
        
        // 获取第一个有权限的标签名
        const firstAuthTab = tabs.find(tab => this.hasAuth(tab.auth));
        
        if (this.$route.query.type && this.hasAuth(this.getTabAuth(this.$route.query.type))) {
            this.activeName = this.$route.query.type;
        } else if (firstAuthTab) {
            this.activeName = firstAuthTab.name;
        }
    },
    methods: {
        hasAuth(code) {
            return this.$store.getters.rescodelist.includes(code);
        },
        getTabAuth(name) {
            const authMap = {
                'first': 'customerLvyueTable2026',
                'second': 'customerLvyueTable2026Increment',
                'third': 'customerLvyueTable2026XY',
                'fourth': '/customerLvyueTable2026HH'
            };
            return authMap[name];
        }
    }
}
</script>
<style scoped>
.h-content{
    background: #fff
}
</style>
